import * as React from "react";
import {Card} from "semantic-ui-react";

export interface ICardData {
    header: string;
    meta?: string;
    description?: JSX.Element;
    cnr:string | string[];

}

interface ICardSelectProps {
    items: any[];
    assignTo: string;
    selectedIndex?: number;
    displayItems?: number;
    mapToCard: (content: any) => ICardData;
    onIndexChange: (idx: number | undefined) => void;
    t: reactI18Next.TranslationFunction;
}

interface ICardSelectState {
    carouselPage: number;
}

class CardSelect extends React.Component<ICardSelectProps, ICardSelectState> {
    constructor(props: ICardSelectProps) {
        super(props);
        this.state = {
            carouselPage: 0,
        };
    }
    changeIndex(i: number) {
        if (i !== this.props.selectedIndex)
            this.props.onIndexChange(i);
        else
            this.props.onIndexChange(undefined);
    }

    indexValid(i: number) {
        return i >= 0 && i < this.props.items.length;
    }

    next = () => {
        let nextPage = this.state.carouselPage + 1;
        if (nextPage >= Math.ceil(this.props.items.length / 4)) {
            nextPage = 0;
        }

        this.setState({carouselPage: nextPage});
        setTimeout(
            () => {
                this.setState({carouselPage: nextPage});
            },
        );
    }

    previous = () => {
        let previousPage = this.state.carouselPage - 1;
        if (previousPage < 0) {
            previousPage = Math.ceil(this.props.items.length / 4) - 1;
        }

        this.setState({carouselPage: previousPage});
        setTimeout(
            () => {
                this.setState({carouselPage: previousPage});
            },
        );
    }

    render() {
        if (this.props.selectedIndex !== undefined && !this.indexValid(this.props.selectedIndex)) {
            if (this.props.selectedIndex < 0) {
                this.props.onIndexChange(0);
            } else {
                this.props.onIndexChange(this.props.items.length - 1);
            }
        }
        const itemsWithIndex = this.props.items.map((item, index) => ({...item, index}));
        return (
            <div className="CardSelectCarousel">
                <div
                    className='SpecConfigArrowContainer'
                    onClick={this.previous}
                >
                    <div className='SpecConfigArrowLeft'/>
                </div>

                <div className='CardSelectContainer'>
                    {itemsWithIndex.slice(this.state.carouselPage * 4, (this.state.carouselPage + 1) * 4).map((val) => {
                        const c: ICardData = this.props.mapToCard(val);
                        return (
                                <Card
                                    key={val.index}
                                    fluid={true}
                                    className={val.index === this.props.selectedIndex
                                        ? "CardSelectSelectedCard SpecConfigCard" : "SpecConfigCard"}
                                >
                                    <Card.Content>
                                        <Card.Header className="CardSelectSelectable" onClick={() => this.changeIndex(val.index)}>
                                            {c.cnr ? this.props.t(`GLOBAL:${c.cnr}`) : c.header}
                                        </Card.Header>
                                        <Card.Meta>{c.meta}</Card.Meta>
                                        <Card.Description>{c.description}</Card.Description>
                                    </Card.Content>
                                </Card>
                            );
                    })}
                </div>

                <div
                    className='SpecConfigArrowContainer'
                    onClick={this.next}
                >
                    <div className='SpecConfigArrowRight'/>
                </div>
            </div>
        );
    }
}

export default CardSelect;



// WEBPACK FOOTER //
// ./src/views/AdminView/SpecConfigTab/CardSelect.tsx